import http from "../../services/httpService";
import { injectHtml, injectHtmlIntoEntity } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import { isBrowserChrome, error, isEmpty, initToggleIconRotate, rotateElement } from "../common/global";
import { openSnackbar, snackbarModel } from "../common/snackbar";
import forms from "../common/forms"
import { catchError } from "../../utils/errorUtil";

const props = {

    //CHECKOUT INDEX VIEW
    checkoutIndexMarker: '#checkout-index-wrapper',

    //YOUR DETAILS
    yourDetailsIndicatorIcon: '#your-details-indicator',
    yourDetailsEmailAddress: '#CustomerEmailAddress',

    yourDetailsDeliveryRegion: '#DeliveryRegionId',
    yourDetailsDeliveryInfoWrapper: '#delivery-region-information-wrapper',
    yourDetailsDeliveryInfoIconSuccess: '#delivery-region-information-success',
    yourDetailsDeliveryInfoIconFailure: '#delivery-region-information-failure',
    yourDetailsDeliveryInfoContent: '#delivery-region-information-content',

    //ADDRESS MANAGEMENT
    addressIndicatorIcon: '.address-indicator',
    addressSelectedWrapper: '.address-selected-wrapper',
    addressExistingWrapper: '.address-existing-wrapper',
    addressNewWrapper: '.address-new-wrapper',
    addressFinderWrapper: '.address-finder-wrapper',
    addressEnterManually: '.address-enter-manually',
    addressDetailsWrapper: '.address-details-wrapper',

    addressExistingInstance: '.address-existing-instance',

    addressSectionWrapper: '.address-section-wrapper',
    addressEditExistingWrapper: '.address-edit-existing-wrapper',
    addressEditExistingInner: '.address-edit-existing-inner',

    //represents the hidden field on the 'edit address' form for the address in question
    addressEditIdElement: '.edit-address-id',

    manageAddressWrapper: '.manage-address-wrapper',
    changeAddress: '.change-address',
    selectExistingAddress: '.select-existing-address',
    editExistingAddress: '.edit-existing-address',
    manageAddressSubmit: '.manage-address-submit',

    //BILLING ADDRESS SPECIFIC

    billingAddressSectionWrapper: '#billing-address-wrapper',
    billingAddressSameAsDeliveryCheckbox: '#billing-use-delivery-address',
    billingAddressManagementWrapper: '#billing-address-management-wrapper',

    //DEALERSHIP SELECTION MANAGEMENT
    deliveryDealershipWrapper: '#delivery-dealership-wrapper',
    dealershipSelectedWrapper: '.dealership-selected-wrapper',
    dealershipMapSelectionWrapper: '.dealership-map-selection-wrapper',
    changeDealership: '#change-dealership',
    selectExistingDealership: '.select-dealership',
    dealershipIndicatorIcon: '.dealership-indicator',

    //PLACE ORDER
    placeOrder: '#place-order',
    customerDetailsForm: '#customer-details-form',

    //DELIVERY NOTES
    deliveryNotesCaptureElement: '#customer-delivery-notes-capture',
    deliveryNotesFormElement: '#CustomerDeliveryNotes'

};

let parentSectionWrapperEntity = null;

let customerDetailsValidator = null;

let addressControl = null;

//add to basket properties. used during an 'add to basket' lifecycle.

export function initCheckoutView() {

    if ($(props.checkoutIndexMarker).length) {
        initCheckoutIndexEvents();

        checkoutLoadEvent();
    }
}


async function initCheckoutIndexEvents() {

    //this is the entry point whenever the checkout is loaded. as such it binds any events that may be required upon load. these are:

    // - all scenarios; have user contact details been completed?
    initUserDetailsEvents();

    // - all scenarios; initialise events related to the 'billing address uses delivery address' checkbox
    initBillingAddressSameEvents();

    // - accounts without existing addresses; new address events
    initEnterNewAddressEvents();

    // - accounts with a selected address; selected address events
    initSelectedAddressEvents();

    //run all sections complete check to see whether the 'place order' CTA should be enabled
    allRequiredSectionsComplete();

    //call the billing address load event on page load
    billingAddressLoadEvent();

    //initialise the function that will 'fix / pin' the basket items panel when the page is scrolled down beyond a certain point
    initFixBasketDetailsPanelOnScroll();

    //call the worker (used in the event registered directly above ) on load in case the page loads with the viewport scrolled down.
    basketDetailsScrollWorker();

    //init validator for cust details form
    initCustomerDetailForm();

    //init change dealership events
    initChangeDealershipEvents();

    //check upon load to see if the place order event should be bound
    allRequiredSectionsComplete();

    initialiseCustomerDeliveryNotesEvents();
}

//NOTES ON ADDRESS IMPLEMENTATION IN CHECKOUT

//as functions can be reused by multiple instances of the address functionality the html and js is structured to use 
//element selectors based on classes within a parent object.

//the parent object is set using the active element when an event is triggered. it is then picked up and used to find instances of required elements to 
//preform various actions (depending upon requirements).

//this means that delivery and billing address structures need to have the same core structure and work in the same way. if they need to behave differently this
//approach will need to be reconsidered. 

function initUserDetailsEvents() {

    $(props.yourDetailsEmailAddress).off('blur').on('blur', function () {
        userDetailsChangeHelper();
    });

    $(props.yourDetailsDeliveryRegion).off('change').on('change', function () {
        userDetailsChangeHelper();

        userDetailsChangeDeliveryRegionHelper();
    });

    userDetailsChangeHelper();
}

function userDetailsChangeHelper() {

    var detailsComplete = true;

    if (isEmpty($(props.yourDetailsEmailAddress).val())) {
        detailsComplete = false;
    }

    if (isEmpty($(props.yourDetailsDeliveryRegion).val()) || $(props.yourDetailsDeliveryRegion).val() !== '1') {

        //if a region is NOT selected or the region selected is NOT UK (excl NI) then details are incomplete
        detailsComplete = false;
        $(props.deliveryDealershipWrapper).hide(500);
    }
    else {

        $(props.deliveryDealershipWrapper).show(500);
    }

    //ML: decide to make contact number optional. See what client says.
    //if (isEmpty($(props.yourDetailsPhoneNumber).val())) {
    //    detailsComplete = false;
    //}

    //use setUserDetailsIndicatorIcon helper method to display the indicator icon as green (complete) or grey (incomplete)
    setUserDetailsIndicatorIcon(detailsComplete);
}

function userDetailsChangeDeliveryRegionHelper() {

    if (isEmpty($(props.yourDetailsDeliveryRegion).val())) {

        //no region selected
        userDetailsChangeDeliveryRegionInformationHelper(false, false, '');

    }

    if ($(props.yourDetailsDeliveryRegion).val() === '1') {

        //UK (excl NI) selected
        userDetailsChangeDeliveryRegionInformationHelper(true, true, 'We deliver to the selected region.');
    }

    if ($(props.yourDetailsDeliveryRegion).val() === '2') {

        //Northern Ireland selected
        var northernIrelandContent = 'Thank you for your enquiry to purchase a Hayter product. Our Irish Distributor has an extensive network of Dealers who can supply our products. ';
        northernIrelandContent = northernIrelandContent + '<div class="mt-2">Please email <a href="mailto:Hayter-sales@cyriljohnston.com">Hayter-sales@cyriljohnston.com</a> to make contact and to find your closest Dealer.</div>';

        userDetailsChangeDeliveryRegionInformationHelper(true, false, northernIrelandContent);
    }

    if ($(props.yourDetailsDeliveryRegion).val() === '3') {

        //Republic of Ireland selected
        var irelandContent = 'Thank you for your enquiry to purchase a Hayter product. Our Irish Distributor has an extensive network of Dealers who can supply our products. ';
        irelandContent = irelandContent + '<div class="mt-2">Please email <a href="mailto:Hayter-sales@cyriljohnston.com">Hayter-sales@cyriljohnston.com</a> to make contact and to find your closest Dealer.</div>';

        userDetailsChangeDeliveryRegionInformationHelper(true, false, irelandContent);
    }

    if ($(props.yourDetailsDeliveryRegion).val() === '4') {

        //Rest of world
        userDetailsChangeDeliveryRegionInformationHelper(true, false, 'We are currently unable to take orders for delivery outside of the United Kingdom.');
    }
}

function userDetailsChangeDeliveryRegionInformationHelper(showInfo, success, content) {

    $(props.yourDetailsDeliveryInfoWrapper).hide(500, function () {

        $(props.yourDetailsDeliveryInfoIconSuccess).hide();
        $(props.yourDetailsDeliveryInfoIconFailure).hide();
        $(props.yourDetailsDeliveryInfoContent).html('');

        if (showInfo) {

            if (success) {

                $(props.yourDetailsDeliveryInfoIconSuccess).show();

            } else {

                $(props.yourDetailsDeliveryInfoIconFailure).show();

            }

            $(props.yourDetailsDeliveryInfoContent).html(content);

            $(props.yourDetailsDeliveryInfoWrapper).show(500);
        }
    });

}

function initEnterNewAddressEvents() {

    $(props.addressEnterManually).off('click').on('click', function () {

        //as an entry point for an action we detect and assign the 'parent section wrapper' that the active element resides within.
        setParentSectionWrapperEntity($(this));

        //runs standard add to basket function; also runs product page specific animation / action.
        buildNewAddressForm(null);
    });  
}

function initialiseLoquateEntities() {

    //NOTE: whilst we have a delivery and billing address we use an injected common form for managing both address types.
    //as such we only register one form 'type' for loquate, and will initialise it when the form is injected onto the page

    //loquate initialisation
    var addressFields = [
        { element: "address-search", field: "" },
        { element: "Address1", field: "Line1" },
        { element: "Address2", field: "Line2", mode: pca.fieldMode.POPULATE },
        { element: "Address3", field: "City", mode: pca.fieldMode.POPULATE },
        { element: "City", field: "Province", mode: pca.fieldMode.POPULATE },
        { element: "Postcode", field: "PostalCode" }
    ];

    var addressOptions = { key: "ZC65-ZN49-DG59-RE95", countries: { codesList: "GBR" }, setCountryByIP: false };

    addressControl = new pca.Address(addressFields, addressOptions);

    //prevents chrome ac getting in the way
    if (isBrowserChrome() === true) {

        for (var i = 0; addressControl.fields.length > i; i++) {

            $('#' + addressControl.fields[i].element).prop('autocomplete', 'PCATEST');

        };
    };
}

async function initSelectedAddressEvents() {

    //bind change address event for the displayed selected address
    $(props.changeAddress).off('click').on('click', async function () {

        //as an entry point for an action we detect and assign the 'parent section wrapper' that the active element resides within.
        await setParentSectionWrapperEntity($(this));

        setAddressIndicatorIcon(false);

        //call function to get all existing addresses and inject the built partial into the page
        getExistingAddresses();
    });
}

async function initBillingAddressSameEvents() {

    $(props.billingAddressSameAsDeliveryCheckbox).off('change').on('change', async function () {

        if ($(props.billingAddressSameAsDeliveryCheckbox).is(':checked')) {

            await setParentSectionWrapperEntity($(this));

            //set address indicator icon for the billing section to complete
            setAddressIndicatorIcon(true);

            await billingAddressUsesDeliveryAddress(true);

            $(props.billingAddressManagementWrapper).hide(500, function () {

                //once the wrapper is closed hide the existing and new child wrappers to ensure smooth animation if this section is reopened
                parentSectionWrapperEntity.find(props.addressExistingWrapper).hide();
                parentSectionWrapperEntity.find(props.addressNewWrapper).hide();
            });
        }
        else {

            //cal service to clear selected default billing address
            await billingAddressUsesDeliveryAddress(false);

            await setParentSectionWrapperEntity($(this));

            //set address indicator icon for the billing section to incomplete
            setAddressIndicatorIcon(false);

            //hide the selected address wrapper before calling the 'get existing address' function to smooth UI animation
            parentSectionWrapperEntity.find(props.addressSelectedWrapper).hide();

            $(props.billingAddressManagementWrapper).show();

            await getExistingAddresses();
        }
    });
}

async function billingAddressLoadEvent() {

    //call upon page load; sets the billing address section depending upon the status of the'use delivery address' checkbox and the data available
    //NOTE: due to the 'select dealership' functionality we do not always display the billingAddressSameAsDeliveryCheckbox checkbox
    if ($(props.billingAddressSameAsDeliveryCheckbox).length == 0 || !$(props.billingAddressSameAsDeliveryCheckbox).is(':checked')) {

        await setParentSectionWrapperEntity($(props.billingAddressSectionWrapper));

        //hide the selected address wrapper before calling the 'get existing address' function to smooth UI animation
        if (isEmpty(parentSectionWrapperEntity.data('said'))) {

            parentSectionWrapperEntity.find(props.addressSelectedWrapper).hide();
        }

       //(props.billingAddressManagementWrapper).show();

        if (isEmpty(parentSectionWrapperEntity.data('said'))) {

            await getExistingAddresses(false);
        }
    }
}

async function billingAddressUsesDeliveryAddress(setAsSameAddress) {

    //this function calls a server side service that either:
    // - setAsSameAddress = true. billing address for user is set to same as current default delivery address
    // - setAsSameAddress = false. default billing address for user is cleared.

    const data = { setAsSame: setAsSameAddress };
    const result = await billingAddressUsesDeliveryAddressService(data);
}

async function buildNewAddressForm(addressId) {

    //calls the server; this builds a form for a new address and returns it to the client. this is then injected into the page.
    //first, find and remove any pre-existing instances of the partial to-be-injected on the page
    $(props.manageAddressWrapper).remove();

    var sectionAddressType = await getParentSectionWrapperAddressType();

    const data = { addressId: addressId, addressType: sectionAddressType };
    const result = await getAddressForEditService(data);

    await injectHtmlIntoEntity(parentSectionWrapperEntity.find(props.addressDetailsWrapper), result);

    setTimeout(function () {

        //open the 'wrapper' element for a new address now that the form has been injected 
        parentSectionWrapperEntity.find(props.addressDetailsWrapper).show(500, function () {

            initialiseLoquateEntities();

            initSaveAddressEvents(props.addressNewWrapper);

            //scroll the page to the form to present it to the user
            forms.scrollToElement(parentSectionWrapperEntity.find(props.addressNewWrapper), 500, true);
        });

    }, 100);
}

async function initSaveAddressEvents(hideUponSuccess) {

    //initialises entities and events for the saving of a new address or updatign an existing item
    //the property hideUponSuccess
    catchError(async function () {

        const formObject = parentSectionWrapperEntity.find('form#edit-address-form');
        const save_button_selector = parentSectionWrapperEntity.find('button.submit-element');

        //only attempt validation / binding if the form is present
        if (formObject.length > 0) {

            //initialise jquery validation for the injected form
            const validator = forms.onloadValidationSetupByObject(formObject);

            $(save_button_selector).off('click').on('click', async function () {

                await setParentSectionWrapperEntity($(this));

                //validate form
                if (formObject.valid()) {

                    const activityIndicator = parentSectionWrapperEntity.find('.submit-address-activity');

                    activityIndicator.show().css("display", "inline-block");

                    //disables any other buttons etc on the page 
                    forms.formUnderSubmission(true);

                    setTimeout(async function () {

                        const formValues = formObject.serialize();

                        //attempt POST save, the check response
                        const response = await saveAddressService(formValues);

                        if (response.responseType === "SUCCESS") {

                            //close edit form. 
                            parentSectionWrapperEntity.find(props.addressExistingWrapper).hide(500);

                            parentSectionWrapperEntity.find(hideUponSuccess).hide(500, async function () {

                                //remove manage address form for future display purposes
                                $(props.manageAddressWrapper).remove();

                                //display updated address item
                                await getSelectedAddress(response.id);

                                var addressType = await getParentSectionWrapperAddressType();

                                //set the address item as selected via the server. this sets the default delivery / billing address for the current user to be the address just saved.
                                setSelectedAddress(response.id, addressType);

                                //set a snackbar message to provide feedback to the user that the action is complete
                                var snackbarMessage = 'Address created';

                                if (!isEmpty($(props.addressEditIdElement))) {

                                    snackbarMessage = 'Address updated';
                                }

                                openSnackbar({
                                    ...snackbarModel,
                                    content: snackbarMessage
                                });

                            });
                        }
                        else {

                            //saving address was unsuccessful. display error message to user.
                            error(response.responseMessage, true);
                        }

                        //re-enables other action elements on the page
                        forms.formUnderSubmission(false);
                        activityIndicator.hide();

                    }, 1000);
                } else {

                    var inValid = parentSectionWrapperEntity.find('.input-validation-error');
                    inValid.prop('placeholder', 'This field is required');

                    forms.scrollToFirstError(validator, $(document).height() * 0.5);
                }
            });
        }
    });
}

async function setSelectedAddress(addressId, addressType) {

    //sets the passed address id as the default address for the current user of the passed address type (i.e. delivery and / or billing)
    const data = { addressId: addressId, addressType: addressType };
    const response = await setSelectedAddressService(data);

    if (response.responseType !== "SUCCESS") {

        //saving address was unsuccessful. display error message to user.
        error(response.responseMessage, true);
    }
    else {

        var billingAddressSectionWrapperEntity = $(props.billingAddressSectionWrapper);

        if (!billingAddressSectionWrapperEntity.is(':visible')) {

            var indicatorIcon = billingAddressSectionWrapperEntity.find(props.addressIndicatorIcon);

            setIndicatorIconHelper(true, indicatorIcon);

            billingAddressSectionWrapperEntity.show(500);
        }
    }
}

async function getSelectedAddress(addressId) {

    //calls the server to get the details of the selected address item.
    //the view returned displays address details in a readonly format
    const data = { addressId: addressId };
    const result = await getSelectedAddressService(data);

    await injectHtmlIntoEntity(parentSectionWrapperEntity.find(props.addressSelectedWrapper), result);

    setTimeout(function () {

        //update delivery address complete indicator
        setAddressIndicatorIcon(true);

        //init standard mdc elements
        parentSectionWrapperEntity.find(props.addressNewWrapper).hide(500);
        parentSectionWrapperEntity.find(props.addressExistingWrapper).hide(500, function () {

            parentSectionWrapperEntity.find(props.addressSelectedWrapper).show(500, function () {

                //scroll to relevant element to display the 'select address' section
                //forms.scrollToElement(parentSectionWrapperEntity.find(props.addressExistingWrapper), 500);
                initSelectedAddressEvents();
            });
        });
                
    }, 100);
}

async function getExistingAddresses(autoScroll = true) {

    //calls the server to get all currently available addresses for the current user.
    //this is returned as a styled view, where the addresses are displayed as a list. 
    //each address item has events registered (select / edit)
    var addressType = await getParentSectionWrapperAddressType();

    const data = { addressType: addressType };
    const result = await getExistingAddressesService(data);

    await injectHtmlIntoEntity(parentSectionWrapperEntity.find(props.addressExistingWrapper), result);

    setTimeout(function () {

        //close address selected wrapper, then open the existing addresses section
        parentSectionWrapperEntity.find(props.addressSelectedWrapper).hide(500, function () {

            parentSectionWrapperEntity.find(props.addressExistingWrapper).show(500, async function () {

                if (autoScroll) {
                    //once open scroll to a relevant element to focus the relevant section of the page (in the viewer)
                    forms.scrollToElement(parentSectionWrapperEntity, 500, true);
                }

                //bind event for 'select this address'
                $(props.selectExistingAddress).off('click').on('click', async function () {

                    //as an entry point for an action we detect and assign the 'parent section wrapper' that the active element resides within.
                    setParentSectionWrapperEntity($(this));

                    var existingAddressWrapper = $(this).closest(props.addressExistingInstance);
                    var addressId = existingAddressWrapper.data('id');

                    //get the details of the selected address as a styled partial view and display on the page
                    await getSelectedAddress(addressId);

                    var addressType = await getParentSectionWrapperAddressType();

                    //call a server function to set the selected address as the default address item for the current user (of the address type passed)
                    setSelectedAddress(addressId, addressType);


                    openSnackbar({
                        ...snackbarModel,
                        content: 'Address selected for order'
                    });
                });

                //bind event for 'edit this address'
                $(props.editExistingAddress).off('click').on('click', async function () {

                    //as an entry point for an action we detect and assign the 'parent section wrapper' that the active element resides within.
                    setParentSectionWrapperEntity($(this));

                    var existingAddressWrapper = $(this).closest(props.addressExistingInstance);
                    var addressId = existingAddressWrapper.data('id');

                    //call the server to build and return a aprtial view represnting a form that can be used to edit this address item
                    buildEditAddressForm(addressId);
                });    

            });

            //tried combining these together using comma separated selectors in the show call above but it'll only fire the first for some reason
            parentSectionWrapperEntity.find(props.addressNewWrapper).show(500);
        });
    }, 100);
}


async function buildEditAddressForm(addressId) {

    //first, find and remove any pre-existing instances of the partial to-be-injected on the page
    $(props.manageAddressWrapper).remove();

    var sectionAddressType = await getParentSectionWrapperAddressType();

    const data = { addressId: addressId, addressType: sectionAddressType };
    const result = await getAddressForEditService(data);

    await injectHtmlIntoEntity(parentSectionWrapperEntity.find(props.addressEditExistingInner), result);

    setTimeout(function () {

        //init standard mdc elements

        //hide the currently selected address wrapper, and the anew address wrapper elements
        parentSectionWrapperEntity.find(props.addressNewWrapper).hide(500);
        parentSectionWrapperEntity.find(props.addressExistingWrapper).hide(500, function () {

            parentSectionWrapperEntity.find(props.addressEditExistingWrapper).show(500, function () {

                //register the edit form save events and scroll to display the form to the user.
                initSaveAddressEvents(props.addressEditExistingWrapper);

                forms.scrollToElement(parentSectionWrapperEntity, 500, true);
            });
        });

    }, 100);
}

async function initCustomerDetailForm() {

    const formObject = $(props.customerDetailsForm);

    //only attempt validation / binding if the form is present
    if (formObject.length > 0) {

        //initialise jquery validation for the injected form
        customerDetailsValidator = forms.onloadValidationSetupByObject(formObject);
    }
}

async function bindPlaceOrderEvent() {

    $(props.placeOrder).prop('disabled', false);

    //the click event associated with the 'place order' button is only bound when the checkout is in a state to be submitted
    $(props.placeOrder).off('click').on('click', async function () {

        //first, validate the customer details form data

        //if this is successful post details to an end point; the server will then validate the order (based on it's configuration).
        //if any required information is missing the checkout will be redisplayed with an error message.

        //otherwise the user will be redirected to sagepay (handled server side).
        catchError(async function () {

            const formObject = $(props.customerDetailsForm);
            const placeOrderElement = $(props.placeOrder);

            //validate form
            if (formObject.valid()) {

                //switch out place order text with a submit-activity animation
                placeOrderElement.find('.place-order-text').hide();
                placeOrderElement.find('.place-order-activity').show();

                //disables any other buttons etc on the page 
                forms.formUnderSubmission(true);

                setTimeout(async function () {

                    formObject.submit();

                }, 1000);
            } else {

                forms.scrollToFirstError(customerDetailsValidator, $(document).height() * 0.5);
            }
        });
    });   
}

//START - DEALERSHIP MANAGEMENT

async function initChangeDealershipEvents() {

    //change dealership
    $(props.changeDealership).off('click').on('click', async function () {
               
        catchError(async function () {

            //first, clear the selected dealership
            await setSelectedDealership(null);

            //hide selected ds element, show ds map selection element
            $(props.dealershipSelectedWrapper).hide(500, function () {

                $(props.dealershipMapSelectionWrapper).show(500, function () {

                    //no events to regsiter. all events for map are registered upon page load.
                });
            });
        });
    });
}

export async function initDealershipMapEvents() {

    //select dealership
    $(props.selectExistingDealership).off('click').on('click', async function () {

        var dealershipId = $(this).data('id');

        catchError(async function () {

            //first, set the selected dealership
            await setSelectedDealership(dealershipId);

            //then call load event for selected ds. this will also handle animation of view.
            await getSelectedDealership(dealershipId);
        });
    });
}

async function setSelectedDealership(dealershipId) {

    //sets the passed dealership id as the dealership the customer wants their order to be sent to
    const data = { dealershipId: dealershipId };
    const response = await setSelectedDealershipService(data);

    if (response.responseType !== "SUCCESS") {

        //saving set dealership was unsuccessful. display error message to user.
        error(response.responseMessage, true);
    }
    else {

        var deliveryDealershipWrapperEntity = $(props.deliveryDealershipWrapper);

        var indicatorIcon = deliveryDealershipWrapperEntity.find(props.dealershipIndicatorIcon);

        if (isEmpty(dealershipId)) {
            //set dealership has been cleared. set the 'section complete' icon to grey
            setIndicatorIconHelper(false, indicatorIcon);
        }
        else {

            //set dealership has been set. set the 'section complete' icon to green
            setIndicatorIconHelper(true, indicatorIcon);
        }
    }
}

async function getSelectedDealership(dealershipId) {

    //calls the server to get the details of the selected dealership item.
    //the view returned displays dealership details in a readonly format
    const data = { dealershipId: dealershipId };
    const result = await getSelectedDealershipService(data);

    await injectHtmlIntoEntity($(props.dealershipSelectedWrapper), result);

    setTimeout(function () {

        $(props.dealershipMapSelectionWrapper).hide(500, function () {

            $(props.dealershipSelectedWrapper).show(500, function () {

                //init change event for newly injected button
                initChangeDealershipEvents();
            });
        });

    }, 100);
}



//END - DEALERSHIP MANAGEMENT

function unbindPlaceOrderEvent() {
    $(props.placeOrder).off('click');

    $(props.placeOrder).prop('disabled', true);
}

//HELPER FUNCTIONS
async function setParentSectionWrapperEntity(childEntity) {

    //this function identifies and sets the 'parent element' for a given section based upon the childEntity passed.
    //the parent element jquery entity is assigned to the global variable parentSectionWrapperEntity. this can then be called upon by 'chained' functions.
    parentSectionWrapperEntity = childEntity.closest(props.addressSectionWrapper);
}

async function getParentSectionWrapperAddressType() {

    //NOTE: in order for this function to operate correctly parentSectionWrapperEntity must have previously been set via a call to setParentSectionWrapperEntity
    var addressType = parentSectionWrapperEntity.data('type');

    return addressType;
}

function setUserDetailsIndicatorIcon(complete) {

    var yourDetailsIndicatorIconEntity = $(props.yourDetailsIndicatorIcon);

    //update delivery address complete indicator
    setIndicatorIconHelper(complete, yourDetailsIndicatorIconEntity);
}

function setAddressIndicatorIcon(complete) {

    var addressIndicatorIconEntity = parentSectionWrapperEntity.find(props.addressIndicatorIcon);

    //update delivery address complete indicator
    setIndicatorIconHelper(complete, addressIndicatorIconEntity);
}

function setIndicatorIconHelper(complete, indicatorEntity) {

    if (complete) {
        indicatorEntity.addClass('text-green');
        indicatorEntity.removeClass('colour-red');
    }
    else {

        indicatorEntity.addClass('colour-red');
        indicatorEntity.removeClass('text-green');
    }

    //when an indicator changes for any of the sections check the overall status of the checkout 'form'
    allRequiredSectionsComplete();
}

function allRequiredSectionsComplete() {

    //TODO: need to refactor this based on dealership / delivery address completion
    //base on checkoutVm 'requires inspection' flag?

    //this function looks at the required customer details sections and ascertains whether or not they are complete.
    //if so, the complete order button is made available; if not, it is disabled.
    var allSectionsComplete = true;

    if ($(props.yourDetailsIndicatorIcon).hasClass('colour-red')) {
        allSectionsComplete = false;
    }

    //this next section is dependent upon whether the bought goods will be delivered or sent to a local dealership
    //NOTE: billing address is always required
    if ($(props.deliveryDealershipWrapper).length > 0) {

        //if deliveryDealershipWrapper is present the goods must be sent to the dealership
        var dealershipSectionComplete = $(props.dealershipIndicatorIcon).hasClass('text-green');
        var billingAddressSectionComplete = $(props.billingAddressSectionWrapper).find(props.addressIndicatorIcon).hasClass('text-green');

        //if either the dealership section or the billing address section are incomplete then prevtn the 'place order' button from being enabled
        if (!dealershipSectionComplete || !billingAddressSectionComplete) {
            allSectionsComplete = false;
        }
    }
    else {

        //else, delivery address is required
        if ($(props.addressIndicatorIcon).hasClass('colour-red')) {
            allSectionsComplete = false;
        }
    }


    //bind and enable (or the reverse) the place order event / button based upon whether the form is fully complete
    if (allSectionsComplete) {
        bindPlaceOrderEvent();
    } else {
        unbindPlaceOrderEvent();
    }
}

function initFixBasketDetailsPanelOnScroll() {

    //calculate position of the element #checkout-row from the top of the page.
    //once reached (when scrolling) the basket panel will be fixed in place.
    $(window).scroll(function () {
        basketDetailsScrollWorker();        
    });
}

function basketDetailsScrollWorker() {

    //used to apply a class to the right hand 'basket' panel once the user has scrolled down beyond a vertain point on a page
    var checkoutRowTop = $('#checkout-row').offset().top;

    var basketItemsPanel = $('#checkout-bdp-inner');

    //if the device is not mobile then when the page is scrolled down beyond the position of the checkoutRow element 'fix' the basket items panel
    if ($(window).scrollTop() >= checkoutRowTop && ($(window).width() > 992)) {

        basketItemsPanel.addClass("fix-panel"); // Stick the basket items panel
    }
    else {
        basketItemsPanel.removeClass("fix-panel");
    }
}

function initialiseCustomerDeliveryNotesEvents() {

    //delivery notes text area sites outside of the form used to submit an order.
    //as such we have a hiddenfield in the form; this is updated whenever the delivery notes text area is exited.
    $(props.deliveryNotesCaptureElement).off('blur').on('blur', async function () {

        transferDeliveryNotesToForm();
    });
}

function transferDeliveryNotesToForm() {

    //19/06/2023. Client has requested the removal of the delivery instructions field as their logistics partner doesn't support it.
    //this is called on the exit of the delivery notes text area, and when the form is submitted
    //$(props.deliveryNotesFormElement).val($(props.deliveryNotesCaptureElement).val());
}


//START - GA4 BASKET HELPER FUNCTIONS
async function addToBasketEvent(basketItemId, quantity) {

    var gaProduct = await getBasketItemProductDetails(basketItemId);

    if (gaProduct) {

        if (quantity !== null) {

            //override quantity if value passed
            gaProduct.productItem.quantity = quantity;
            gaProduct.itemValue = gaProduct.itemValueSingle * quantity;
        }

        var addToBasketGaCode = {
            event: "add_to_cart",
            ecommerce: {
                currency: gaProduct.currency,
                value: gaProduct.itemValue,
                items: [gaProduct.productItem]
            }
        }

        //console.log("addToBasketGaCode", addToBasketGaCode);

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(addToBasketGaCode);
    }
}

async function checkoutLoadEvent() {

    var gaCheckout = await getCheckoutLoadModel();

    if (gaCheckout) {

        var checkoutLoadGaCode = {
            event: "begin_checkout",
            ecommerce: {
                currency: gaCheckout.currency,
                value: gaCheckout.basketTotal,
                coupon: gaCheckout.coupon,
                items: [gaCheckout.basketItems]
            }
        }

        //console.log("checkoutLoadGaCode", checkoutLoadGaCode);

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(checkoutLoadGaCode);
    }
}
async function getCheckoutLoadModel() {

    //this function returns an object representing the current basket
    const result = await getCheckoutLoadModelService();

    if (result.responseType == "SUCCESS") {

        return result;
    }
    else {

        return null;
    }
}
//END - GA4 BASKET HELPER FUNCTIONS


//DATA CALLS

async function getSelectedAddressService(data) {

    //gets an empty (new) or populated edit address form for a single address
    const response = await http.get('/address/getselectedaddress', data);

    return response.data;
}

async function setSelectedAddressService(data) {

    //sets an address to be the default address for the logged in user (of the type passed)
    const response = await http.post('/address/setselectedaddress', data);

    return response.data;
}

async function saveAddressService(data) {

    //saves the details of a single address
    const response = await http.post('/address/editaddresspost', data);

    return response.data;
}

async function getExistingAddressesService(data) {

    //gets all current available addresses for this user
    const response = await http.get('/address/getexistingaddresses', data);

    return response.data;
}

async function billingAddressUsesDeliveryAddressService(data) {

    //gets all current available addresses for this user
    const response = await http.post('/address/billingaddressusesdeliveryaddress', data);

    return response.data;
}

async function getAddressForEditService(data) {

    //gets an empty (new) or populated edit address form for a single address
    const response = await http.get('/address/getaddressforedit', data);

    return response.data;
}

//DEALERSHIP MANAGEMENT

async function setSelectedDealershipService(data) {

    //sets or clears the currently selected dealership for a user
    const response = await http.post('/checkout/setselecteddealership', data);

    return response.data;
}

async function getSelectedDealershipService(data) {

    //gets the selected dealership details as a view
    const response = await http.get('/checkout/getselecteddealership', data);

    return response.data;
}

async function getCheckoutLoadModelService() {

    //no TRY CATCH as handled by parent
    //returns json result of remove from basket attempt
    const response = await http.get('/seo/getcurrentcheckoutgafourmodel');

    return response.data;
}